// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rc-2";
export var chatLink = "_rc-0";
export var chatText = "_rc-1";